export default __webpack_public_path__ + "static/media/NZDUSD.972ae6fc.svg";